/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    arrayOf,
    bool,
    func,
    number,
    object,
    shape,
    string,
} from 'prop-types';
import { withRouter } from 'react-router';
import { Dialog, DialogTitle } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from '@material-ui/core/DialogContent';
import FilterIcon from '../../../../BrandTheme/Icons/FilterSvgIcon';
import GraphqlProductFacetsV2 from './GraphqlProductFacetsV2';
import SortFilterOption from '../FilterDialog/DesktopFilterDialog/DesktopFilterDialog';
import useCheckedFacets from '../../../../../helpers/hooks/useCheckedFacets';

const styles = (theme) => ({
    mainDialogData: {
        '& .MuiDialog-paperWidthSm': {
            width: '100%',
        },
        '& .MuiDialogContent-dividers': {
            borderTop: 0,
            [theme.breakpoints.down(481)]: {
                padding: '10px 16px',
            },
        },
        '& .MuiDialogTitle-root': {
            textAlign: 'center',
        },
    },
    closebutton: {
        '& span': {
            width: '170px',
            border: '1px solid',
            margin: '0 auto',
            display: 'block',
            textAlign: 'center',
            padding: '12px 0px',
            fontWeight: '600',
            fontSize: '15px',
            marginBottom: '25px',
            fontFamily: 'Garamond, Times, serif',
            [theme.breakpoints.down(481)]: {
                width: 150,
                padding: '8px 0px',
                fontSize: '16px',
            },
        },
        [theme.breakpoints.down(481)]: {
            marginTop: 10,
        },
    },
    closeX: {
        backgroundColor: 'transparent',
        padding: '1px',
        border: 'none',
        marginTop: '-30px',
        '& svg': {
            color: theme?.palette?.black || '#000000',
        },
    },
    dialogContent: {
        display: 'flex',
        justifyContent: 'space-between',
        '& .MuiDialogTitle-root': {
            padding: '30px 10px 0 25px',
            [theme.breakpoints.down(481)]: {
                padding: '22px 10px 0 16px',
            },
        },
        '& *': {
            textAlign: 'left',
        },
    },
    mobileFilterContainer: {
        [theme.breakpoints.down(599)]: {
            display: 'flex',
            width: '49%',
        },
    },
    filterFacetContainer: {
        alignItems: 'center !important',
    },
});

const GraphqlMobileProductFacetsV2 = ({
    isFoodBrand,
    classes,
    productFacetsBase,
    isFacetFiltersCountEnabled,
    category,
    trackEventAction,
    openDisplayFacets,
    setFacetsDataInCollection,
    svgIconData,
    displayDeliveryMethod,
    isFilterFactsV2,
    presentation_family,
    setFilterDataInCategoryBuilder,
}) => {
    // use for open the Dialog model
    const [isModalOpen, setIsModalOpen] = useState(false);
    const checkedFacetsData = useCheckedFacets();

    const toggleFilterDialog = () => {
        setIsModalOpen(!isModalOpen);
    };

    const noOfFilterParams = (checkedFacetsData?.length && !isFoodBrand) ? checkedFacetsData.length : 0;

    return (
        <>
            <div className={presentation_family === 'flower' ? `${classes.mainFilterContainer} ${classes.filterFacetContainer}` : classes.mainFilterContainer}>
                <div className={classes.fliterFactsV2}>
                    <span className={noOfFilterParams ? classes.selectedFilterButton : ''} role="presentation" onClick={() => toggleFilterDialog()}>
                        {svgIconData(classes, isModalOpen, noOfFilterParams)}
                    </span>
                </div>
                <div className={classes.mobileFilterContainer}>
                    <SortFilterOption
                        displayDeliveryMethod={displayDeliveryMethod}
                        setFilterOptions={setFilterDataInCategoryBuilder}
                        brand={category?.brand}
                        presentationFamily={presentation_family}
                        isFilterFactsV2={isFilterFactsV2}
                    />
                </div>
            </div>
            {isModalOpen
            && (
                <Dialog open={isModalOpen} maxWidth="sm" className={classes.mainDialogData}>
                    <div className={classes.dialogContent}>
                        <DialogTitle className={classes.center} id="customized-dialog-title">
                            Filter <FilterIcon />
                        </DialogTitle>
                        <button type="button" aria-label="close" className={classes.closeX} onClick={toggleFilterDialog}><CloseIcon /></button>
                    </div>
                    <MuiDialogContent dividers>
                        <Typography gutterBottom>
                            <div className={classes.contentpassport}>
                                {productFacetsBase?.length > 0 && (
                                    <GraphqlProductFacetsV2
                                        category={category}
                                        productFacets={productFacetsBase}
                                        setFilterDataInCategoryBuilder={setFacetsDataInCollection}
                                        isFoodBrand={isFoodBrand}
                                        isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                                        track={trackEventAction}
                                        isPopFilterSlider
                                        filterOn="Search"
                                        openDisplayFacets={openDisplayFacets}
                                    />
                                )}
                            </div>
                            <div className={classes.breadcrumbAndFilter}>
                                <SortFilterOption
                                    displayDeliveryMethod={displayDeliveryMethod}
                                    setFilterOptions={setFilterDataInCategoryBuilder}
                                    brand={category?.brand}
                                    presentationFamily={presentation_family}
                                    isFilterFactsV2={isFilterFactsV2}
                                    isPopFilterSlider
                                />
                            </div>
                            <div className={classes.closebutton}>
                                <span role="presentation" onClick={() => toggleFilterDialog()}>Close Filters</span>
                            </div>
                        </Typography>
                    </MuiDialogContent>
                </Dialog>
            )}
        </>
    );
};

GraphqlMobileProductFacetsV2.propTypes = {
    classes: object.isRequired,
    isFoodBrand: bool.isRequired,
    productFacetsBase: arrayOf(shape({
        name: string,
        entries: arrayOf(shape({
            count: number,
            from: number,
            name: string,
            value: string,
        })),
    })),
    isFacetFiltersCountEnabled: bool.isRequired,
    category: shape({
        id: string,
        name: string,
        productFacets: arrayOf(shape({
            name: string,
            entries: arrayOf(shape({
                count: number,
                from: number,
                name: string,
                value: string,
            })),
        })),
    }),
    trackEventAction: func,
    svgIconData: func.isRequired,
    setFacetsDataInCollection: func.isRequired,
    displayDeliveryMethod: bool.isRequired,
    presentation_family: string.isRequired,
    setFilterDataInCategoryBuilder: func.isRequired,
    isFilterFactsV2: bool.isRequired,
    openDisplayFacets: bool,
};

GraphqlMobileProductFacetsV2.defaultProps = {
    productFacetsBase: [],
    category: {},
    trackEventAction: () => {},
    openDisplayFacets: false,
};

export default withRouter(withStyles(styles)(GraphqlMobileProductFacetsV2));
